module.exports = __webpack_public_path__ + "img/auld-lang-syne.f148578f.jpeg";